export default "__VITE_ASSET__c667958a__"